const customErrors = {
    error_000: {
        result: 0,
        msg: 'success',
    },
    error_1000: {
        result: 1000,
        msg: 'Non supported browser',
    },
    error_1130: {
        result: 1130,
        error: 'Moderator not present/ wait for Moderator',
        desc: '',
    },
    error_1140: {
        result: 1140,
        error: 'Previous similar request in process',
        desc: '',
    },
    error_1141: {
        result: 1141,
        error: "Remote streams can't be muted",
        desc: '',
    },
    error_1142: {
        result: 1142,
        error: 'Invalid Device Id',
        desc: 'OverconstrainedError: Invalid device id provided',
    },
    error_1143: {
        result: 1143,
        error: 'Requested device not found',
        desc: 'NotFoundError: Requested device was not found',
    },
    error_1144: {
        result: 1144,
        error: 'Permission denied',
        desc: 'NotAllowedError: The request is not allowed by the user agent or the platform in the current context',
    },
    error_1145: {
        result: 1145,
        error: 'Could not start video source',
        desc: 'NotReadableError: Could not start video source',
    },
    error_1146: {
        result: 1146,
        error: 'Failed to execute getUserMedia on MediaDevices',
        desc: 'TypeError: At least one of audio and video must be requested',
    },
    error_1147: {
        result: 1147,
        error: 'Constraints could be not satisfied',
        desc: 'OverconstrainedError: Video width constraint could not be satisfied',
    },
    error_1148: {
        result: 1148,
        error: 'Constraints could be not satisfied',
        desc: 'OverconstrainedError: Video height constraint could not be satisfied',
    },
    error_1149: {
        result: 1149,
        error: 'Constraints could be not satisfied',
        desc: 'One of the constraints (Height, Width, DeviceId) is not satisfied.',
    },
    error_1150: {
        result: 1150,
        error: 'Reason unknown',
        desc: 'Reason unknown',
    },
    error_1151: {
        result: 1151,
        error: 'A screen share is already running',
        desc: '',
    },
    error_1152: {
        result: 1152,
        error: 'Audio only calls are allowed with your current browser version',
        desc: '',
    },
    error_1153: {
        result: 1153,
        error: 'Unsupported browser',
        desc: '',
    },
    error_1154: {
        result: 1154,
        error: 'Given frame rate is not supported',
        desc: 'Frame rate might be negative or not a number which is not accepted by captureStream method',
    },
    error_1155: {
        result: 1155,
        error: 'Invalid options/parameters',
        desc: 'Invalid options parameters ',
    },
    error_1156: {
        result: 1156,
        error: 'Invalid streamType',
        desc: ' streamType  should be set as canvas for canvas streams and talker for talker streams',
    },
    error_1157: {
        result: 1157,
        error: 'The given canvas element does not exist in the DOM',
        desc: 'The canvas element you have provided does not exist in the DOM',
    },
    error_1158: {
        result: 1158,
        error: 'This browser does not support canvas',
        desc: 'This browser does not support canvas',
    },
    error_1159: {
        result: 1159,
        error: 'Stream not found',
        desc: 'Stream not found',
    },
    error_1160: {
        result: 1160,
        error: 'Media connection failure',
        desc: 'Media connection failure',
    },
    error_1161: {
        result: 1161,
        error: 'Server connection failure',
        desc: 'Server connection failure',
    },
    error_1162: {
        result: 1162,
        error: 'The DOM element does not exist',
        desc: 'The element with DOM reference provided does not exist',
    },
    error_1163: {
        result: 1163,
        error: 'Network disconnected',
        desc: 'Socket or media connection has failed due to network error',
    },
    error_1164: {
        result: 1164,
        error: 'Network reconnected',
        desc: 'Network reconnected',
    },
    error_1165: {
        result: 1165,
        error: 'Reconnect attempt exceeded',
        desc: 'Reconnection failed',
    },
    error_1166: {
        result: 1166,
        error: 'Reconnection timed out',
        desc: 'Reconnection failed',
    },
    error_1167: {
        result: 1167,
        error: 'Publish or subscribe failed',
        desc: 'After reconnection publish or subscibe failed',
    },
    error_1168: {
        result: 1168,
        error: 'Not allowed',
        desc: 'Only moderator has rights to excercise this transaction',
    },
    error_1169: {
        result: 1169,
        msg: 'No listener for event',
        desc: '',
    },
    error_1170: {
        result: 1170,
        error: 'Not supported',
        desc: 'Feature is not enabled because of room config or no licence ',
    },
    error_1171: {
        result: 1171,
        error: 'Room not connected',
        desc: 'Room not connected',
    },
    error_1172: {
        result: 1172,
        error: 'Room connect failed',
        desc: 'Room connect failed',
    },
    error_1173: {
        result: 1173,
        error: 'Floor not granted for participant',
        desc: 'Floor not granted',
    },
    error_1174: {
        result: 1174,
        error: 'Local Recording started already',
        desc: '',
    },
    error_1175: {
        result: 1175,
        error: 'Local Recording not started /stream not having media',
        desc: '',
    },
    error_1176: {
        result: 1176,
        error: 'Moderator declined right to control media devices ',
        desc: '',
    },
    error_1177: {
        result: 1177,
        error: 'MediaDevice state is already in same state',
        desc: '',
    },
    error_1178: {
        result: 1178,
        error: 'Reconnection for a single participant in the room is not allowed',
        desc: 'Reconnection not allowed',
    },
    error_1179: {
        result: 1179,
        error: ' files to upload input array size is 0',
        desc: ' empty file transfer is not allowed',
    },
    error_1180: {
        result: 1180,
        error: ' room is disconected',
        desc: ' file sharing is not allowed on disconnected rooms',
    },
    error_1181: {
        result: 1181,
        error: ' Recieve file operation is not permitted.',
        desc: ' File which you are trying to receive  does not exist.',
    },
    error_1182: {
        result: 1182,
        error: 'file upload failed',
        desc: 'file upload failed ',
    },
    error_1183: {
        result: 1183,
        error: ' file download failed ',
        desc: ' file download failed',
    },
    error_1184: {
        result: 1184,
        error: 'user video resolution inavlid range',
        desc: 'user video resolution inavlid range',
    },
    error_1185: {
        result: 1185,
        error: 'file upload failed ',
        desc: 'file upload failed because provided file list is empty',
    },
    error_1186: {
        result: 1186,
        error: 'file upload failed ',
        desc: 'file size is zero bytes',
    },
    error_1187: {
        result: 1187,
        error: 'file upload failed ',
        desc: 'file upload failed because it exceeded max upload limit',
    },
    error_1188: {
        result: 1188,
        error: 'current state and requested state are same',
        desc: 'current state and requested state are same',
    },
    error_1189: {
        result: 1189,
        error: 'Media device switching not allowed in mute state',
        desc: '',
    },
    error_4121: {
        result: 4121,
        error: 'room already locked / unlocked',
        desc: ' room is already locked/unlocked',
    },
    error_7000: {
        result: 7000,
        error: 'streaming error',
        desc: ' streaming error',
    },
    error_7001: {
        result: 7001,
        error: 'live recording error',
        desc: ' live recording error',
    },
    CC002: {
        cause: 2002,
        msg: 'unexpected-disconnection',
    },
    CC006: {
        cause: 2006,
        msg: 'normal-disconnect',
    },
    error_1190: {
      result: 1190,
      error: 'Exception found',
      desc: 'Could not fetch video size',
  },
};

export default customErrors;



//////////////////
// WEBPACK FOOTER
// ./src/customErrors.js
// module id = 7
// module chunks = 0